import { makeStyles } from '@material-ui/core/styles';

const SBWIDTH = 300;

const useStyles = makeStyles((theme) => ({
  pad: {
    padding: theme.spacing(2),
  },
  system: {
    pageBreakBefore: 'always',
    clear: 'both',
  },
  header: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
  },
  headerChild: {
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    overflow: 'hidden',
  },
  headerChildName: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    overflowX: 'auto',
  },
  headerChildScore: {
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
    '@media print': {
      display: 'block',
    },
    width: 48,
  },
  headerCriteria: {
    lineHeight: 0,
    position: 'absolute',
    fontSize: '12px',
    bottom: theme.spacing(1),
    color: theme.colors.grey,
    fontWeight: 'normal',
  },
  sidebarHeaderChild: {
    marginRight: 15,
  },
  systemHeader: {
    top: 0,
    zIndex: 3,
    paddingLeft: theme.spacing(2),
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    marginTop: '1em',
    marginBottom: '1em',
  },
  checklistMenuHeader: {
    display: 'inline',
    fontSize: 'small',
  },
  wrapper: {
    display: 'flex',
    width: '100%',
    height: (p) => (p.isCourse ? undefined : 'calc(100% - 176px)'),

    '@media print': {
      position: 'relative',
      display: 'block',
      height: 'auto !important',
    },
  },
  listItemWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    height: '100%',
    alignItems: 'center',
  },
  listItemWrapChild: {
    paddingLeft: theme.spacing(3),
  },
  expandIcon: {
    position: 'absolute',
    right: 5,
  },
  right: {
    position: 'relative',
    width: (p) => (p.isCourse || p.isMobile || p.printView ? '100%' : `calc(100% - ${SBWIDTH}px)`),
    maxWidth: (p) => (p.isCourse ? undefined : theme.breakpoints.values['lg']),
    [theme.breakpoints.up('xl')]: {
      marginLeft: (p) => (p.printView || p.isCourse ? undefined : `calc(50% - ${theme.breakpoints.values['lg'] / 2}px - ${SBWIDTH}px)`),
    },
    right: 0,
    padding: theme.spacing(1),
    [theme.breakpoints.down('lg')]: {
      padding: 0,
      width: '100%',
    },
    '@media print': {
      width: '100%',
    },
  },
  activeEditContainer: {},
  toggleSidebar: {
    // position: 'absolute',
    // right: 10,
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
    '@media print': {
      display: 'none',
    },
  },
  showImages: {
    color: theme.palette.secondary.main,
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
    '@media print': {
      display: 'none',
    },
  },
  checklistActive: {
    fontWeight: 'bold',
    color: theme.palette.text.primary,
    borderTop: `1px solid ${theme.palette.action.disabledBackground}`,
    borderBottom: `1px solid ${theme.palette.action.disabledBackground}`,
  },
  checklistInactive: {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.text.disabled,
  },
  systemActive: {
    fontWeight: 'bold',
    color: theme.palette.text.primary,
  },
  systemInactive: {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.text.disabled,
  },
  grow: {
    flexGrow: 1,
  },
  show: {
    display: 'block',
  },
  hide: {
    display: 'none',
  },
  leftSidebar: {
    width: SBWIDTH,
    position: 'sticky',
    alignSelf: 'flex-start',
    top: 0,
    overflowY: 'scroll',
    height: '100%',
    maxHeight: '100vh',
  },
  leftSidebarMobile: {
    '& .MuiDrawer-paper': {
      width: '80%',
    },
  },
  drawerPaper: {
    width: SBWIDTH,
    top: 177,
    bottom: 0,
    height: 'auto',

    '& .MuiList-padding': {
      padding: 0,
    },
  },
  overallScore: {
    textAlign: 'center',
    fontWeight: 'bold',
    justifyContent: 'center',
  },
}));

export const filterStyles = makeStyles((theme) => ({
  container: {
    top: 0,
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    zIndex: 3,
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    pointerEvents: 'auto',

    '@media print': {
      display: 'none',
    },
  },
  wrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: `${theme.spacing(1.5)}px 0`,
    maxWidth: 310,
    width: '100%',
    height: 120,
    flexWrap: 'wrap',
  },
  searchContainer: {
    minWidth: '100%',
  },
  switchContainer: {
    width: '50%',
  },
  switchFlex: {
    display: 'flex',
  },
  center: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  select: {
    borderRadius: 4,
    '& .MuiFilledInput-input': {
      padding: '5px 12px 6px',
      paddingRight: 32,
    },
  },
  selectSelected: {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.common.white} !important`,
  },
}));

export const multiStyles = makeStyles((theme) => ({
  scorecardTitle: {
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: theme.spacing(1),
  },
}));

export default useStyles;
